import { WidgetInitializer } from "../functions/widget-initializer";
import { Constants } from "../functions/constants";

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.INSTAGRAM_SOCIAL_FEED);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.INSTAGRAM_SOCIAL_FEED, function () {
    widgetInitializer.initialize(initSocialShareApp);
});

function initSocialShareApp(element) {
    var vueApp = new Vue({
        el: '#' + element.id,
        data: {
            initializationReadyHook: GlobalApp.getInitializationReadyHook(),
            username: '',
            profile_pic: '',
            posts: null,
            followers: null,
            following: null,
            biography: null,
            images: [],
            numberOfImages: 4
        },
        computed: {
            profile_link() {
                return `https://instagram.com/${this.username}`;
            }
        },
        methods: {
            init: function init() {
                var that = this;

                fetch(`/rdo-api/instagram-api?mediaCount=${this.numberOfImages}`).then((response) => {
                    return response.json();
                }).then((data) => {
                    var isError = GlobalApp.ErrorHandler.handle(data);
                    if (isError)
                        return;

                    this.username = data.Username;
                    this.profile_pic = data.ProfilePictureUrl;
                    this.posts = data.MediaCount;
                    this.followers = data.FollowersCount;
                    this.following = data.FollowsCount;
                    this.biography = data.Biography;
                    data.MediaData.map(el => {
                        this.images.push({
                            style: `background-image:url('${el.MediaUrl}')`,
                            bgi: el.MediaUrl,
                            link: el.PostUrl,
                            source: el.MediaUrl,
                            isVideo: el.MediaUrl.indexOf('.mp4') > -1
                        });
                    });
                }).catch(function (err) {
                    console.warn(Constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG, err);
                }).finally(function () {
                    that.initializationReadyHook(element.id);
                    document.lazyLoadAssetCover.update();
                });
            }
        },
        created: function () {
            this.init();
        }
    });

    return vueApp.$el;
}